(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptLanguage', RptLanguage);

    RptLanguage.$inject = ['$resource'];

    function RptLanguage ($resource) {
        var resourceUrl =  'api/rpt-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
